package com.arena_web.data.repository

import com.arena_web.data.api.CardApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.CardRepository

class CardRepositoryImpl(
    private val cardApi: CardApi,
) : CardRepository {

    override suspend fun getMyCards(): Result<List<UserCardDto>> =
        apiCall { cardApi.getMyCards() }

    override suspend fun getUserCards(userId: String): Result<List<UserCardDto>> =
        apiCall { cardApi.getUserCards(userId) }

    override suspend fun purchaseCard(request: PurchaseCardRequest): Result<List<UserCardDto>> =
        apiCall { cardApi.purchaseCard(request) }

    override suspend fun generateAvatar(
        cardId: String,
        sessionId: String,
        fileBytes: ByteArray,
        fileName: String,
        contentType: String,
        prompt: String?
    ): Result<CardAvatarAttemptDto> =
        apiCall { cardApi.generateAvatar(cardId, sessionId, fileBytes, fileName, contentType, prompt) }

    override suspend fun refineAvatar(
        cardId: String,
        sessionId: String,
        attemptId: String,
        prompt: String
    ): Result<CardAvatarAttemptDto> =
        apiCall { cardApi.refineAvatar(cardId, sessionId, attemptId, prompt) }

    override suspend fun generateFromCard(
        cardId: String,
        sessionId: String,
        profileCardId: String,
        prompt: String
    ): Result<CardAvatarAttemptDto> =
        apiCall { cardApi.generateFromCard(cardId, sessionId, profileCardId, prompt) }

    override suspend fun getAvatarAttempts(
        cardId: String,
        sessionId: String,
    ): Result<List<CardAvatarAttemptDto>> =
        apiCall { cardApi.getAvatarAttempts(cardId, sessionId) }

    override suspend fun confirmAvatar(
        cardId: String,
        request: ConfirmCardAvatarRequest
    ): Result<ProfileCardDto> =
        apiCall { cardApi.confirmAvatar(cardId, request) }

    override suspend fun discardAvatarAttempts(
        cardId: String,
        sessionId: String,
    ): Result<Unit> =
        runCatching {
            val status = cardApi.discardAvatarAttempts(cardId, sessionId)
            if (status.value !in 200..299) {
                throw RuntimeException("Discard failed: ${status.value}")
            }
        }

    override suspend fun getMyProfileCards(): Result<List<ProfileCardDto>> =
        apiCall { cardApi.getMyProfileCards() }

    override suspend fun getUserProfileCards(userId: String): Result<List<ProfileCardDto>> =
        apiCall { cardApi.getUserProfileCards(userId) }

    override suspend fun reorderProfileCards(orderedIds: List<String>): Result<List<ProfileCardDto>> =
        apiCall { cardApi.reorderProfileCards(ReorderProfileCardsRequest(orderedIds)) }

    override suspend fun deleteProfileCard(profileCardId: String): Result<List<ProfileCardDto>> =
        apiCall { cardApi.deleteProfileCard(profileCardId) }

    override suspend fun clearProfileCardAvatar(profileCardId: String): Result<List<ProfileCardDto>> =
        apiCall { cardApi.clearProfileCardAvatar(profileCardId) }
}
